function t(n) {
  return typeof n == "number" ? Number.isNaN(n) : !1;
}
function e(n) {
  return n == null || t(n);
}
function s(n) {
  return !e(n);
}
function i(n) {
  let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e(n) || n === !1 || r.includes(n);
}
function u(n) {
  return i(n, [""]);
}
function f(n) {
  return !u(n);
}
export {
  s as a,
  f as b,
  u as c,
  e as i
};
